// composer/channelDefault.ts — what a video's "Channel default" means for this member right
// now (1.27.60, Settings → Privacy → Your channel). Mirrors the server rule in
// backend/apps/content/visibility.py (gate 4).
import type { AudienceType, VideoChannel } from '@/core/models/post';

/** 'public' / 'unlisted' only exist on video posts (the server 400s them otherwise). */
export function isVideoOnlyAudience(a: AudienceType): boolean {
  return a === 'public' || a === 'unlisted';
}

export function channelDefaultLabel(
  user: { privateAccount?: boolean; videoChannel?: VideoChannel } | null | undefined,
): string {
  const channel = user?.videoChannel ?? 'inherit';
  if (channel === 'public') return 'Public';
  if (channel === 'followers') return 'Followers only';
  return user?.privateAccount
    ? 'Followers only, like your private account'
    : 'Public, like your account';
}
